import type {FolhaComContexto, MenuItemFolha} from './menu.type';
import {getMenuModulos} from './menu.config';
import {obterTodasAsFolhas} from './menu.util';

export interface GrupoClassico {
    label: string;
    itens: MenuItemFolha[];
}

// Ordem e rótulos fiéis ao menu antigo (git show main:src/layout/sidebarMenu/AppMenu.vue).
// EXTRATOS, BOLETOS, DOCUMENTOS FISCAIS e PRODUÇÃO não existiam no antigo — entraram na posição mais próxima do que já havia.
const ORDEM_GRUPOS = [
    'Menu',
    'Lista de Arranque',
    'RELATÓRIOS',
    'RELATÓRIOS DE FATURAMENTO',
    'REQUISIÇÕES',
    'OUTROS',
    'EXTRATOS',
    'LANÇAMENTOS',
    'BOLETOS',
    'DOCUMENTOS FISCAIS',
    'ARTIGOS',
    'PRODUÇÃO',
    'ATIVIDADES',
    'ADMINISTRAÇÃO'
];

// Todo item de menu.config.ts precisa de uma entrada aqui. Item novo sem entrada cai no grupo do
// módulo novo (getGruposClassicos abaixo) em vez de desaparecer, mas o ideal é mapear explicitamente.
const GRUPO_POR_ITEM_ID: Record<string, string> = {
    home: 'Menu',
    'lista-arranque-preenchimento': 'Lista de Arranque',
    'lista-arranque-consulta': 'RELATÓRIOS',
    'diario-bordo': 'RELATÓRIOS',
    'apontamentos-rli': 'RELATÓRIOS',
    'apuracao-nota': 'RELATÓRIOS',
    'curva-abc': 'RELATÓRIOS DE FATURAMENTO',
    'faturamento-notafiscal': 'RELATÓRIOS DE FATURAMENTO',
    'requisicao-compra': 'REQUISIÇÕES',
    'pedido-compra': 'OUTROS',
    finalidade: 'OUTROS',
    'matriz-finalidade': 'OUTROS',
    solicitacao: 'EXTRATOS',
    extrato: 'EXTRATOS',
    conciliacao: 'EXTRATOS',
    lancamento: 'LANÇAMENTOS',
    'lancamento-recorrencia': 'LANÇAMENTOS',
    transferencia: 'LANÇAMENTOS',
    'fluxo-caixa': 'LANÇAMENTOS',
    'boleto-convenio': 'BOLETOS',
    boleto: 'BOLETOS',
    'boleto-remessa': 'BOLETOS',
    'boleto-retorno': 'BOLETOS',
    cte: 'DOCUMENTOS FISCAIS',
    nfse: 'DOCUMENTOS FISCAIS',
    'artigo-classificacao': 'ARTIGOS',
    artigo: 'ARTIGOS',
    'artigo-estoque': 'ARTIGOS',
    'ordem-fabricacao': 'PRODUÇÃO',
    atividades: 'ATIVIDADES',
    colaborador: 'ADMINISTRAÇÃO',
    'grupo-permissao': 'ADMINISTRAÇÃO'
};

export function getGruposClassicos(): GrupoClassico[] {
    const folhas: FolhaComContexto[] = obterTodasAsFolhas(getMenuModulos());

    const itensPorGrupo = new Map<string, MenuItemFolha[]>();

    folhas.forEach((folha) => {
        const grupo = GRUPO_POR_ITEM_ID[folha.item.id] ?? folha.modulo.label;
        const itens = itensPorGrupo.get(grupo) ?? [];
        itens.push(folha.item);
        itensPorGrupo.set(grupo, itens);
    });

    const gruposExtras = [...itensPorGrupo.keys()].filter((grupo) => !ORDEM_GRUPOS.includes(grupo));

    return [...ORDEM_GRUPOS, ...gruposExtras]
        .map((label) => ({label, itens: itensPorGrupo.get(label) ?? []}))
        .filter((grupo) => grupo.itens.length > 0);
}
